const apiUrl = process.env.REACT_APP_API_URL;
export const PostGrup = async ( grup : any, id : string ) => {
    try {
        //console.log("ID: " + grup.id);
        const response = await fetch(`${apiUrl}:8061/projectes/${id}/grups`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                codi: grup.codi,
                alumnes: grup.alumnes,
                id_grup: grup.id,
                gitlab: grup.gitlab,
                tutor: grup.tutor,
            })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
